// [Basis MVP-NATIVE-1] A Basis account identity is 32 bytes (BLAKE3 of an
// ML-DSA-65 public key) and is shown at full width. 40 hex stays valid because
// addresses inside the EVM really are 20 bytes -- that width is the EVM's, not
// a truncation of Basis.
export const ADDRESS_REGEXP = /^0x([a-fA-F\d]{40}|[a-fA-F\d]{64})$/;

export const ADDRESS_LENGTH = 66;

export function addressValidator(value: string | undefined) {
  if (!value) {
    return true;
  }

  return ADDRESS_REGEXP.test(value) ? true : 'Incorrect address format';
}
